import React from 'react';
import {Dropdown} from 'react-bootstrap';
import {toAbsoluteUrl} from "../../../helpers";
import {setLanguage, useLang} from "../../../i18n/KiloITi18n";
import clsx from "clsx";
import {Link} from "react-router-dom";

const languages = [
    {
        lang: 'km',
        name: 'Khmer',
        flag: toAbsoluteUrl('/media/flags/cambodia.svg'),
    },
    {
        lang: 'en',
        name: 'English',
        flag: toAbsoluteUrl('/media/flags/united-states.svg'),
    },
    {
        lang: 'zh',
        name: 'Mandarin',
        flag: toAbsoluteUrl('/media/flags/china.svg'),
    },
    {
        lang: 'vi',
        name: 'Vietnam',
        flag: toAbsoluteUrl('/media/flags/vietnam.svg')
    },
    {
        lang: 'th',
        name: 'Thailand',
        flag: toAbsoluteUrl('/media/flags/thailand.svg')
    },
    {
        lang: 'lo',
        name: 'Laos',
        flag: toAbsoluteUrl('/media/flags/laos.svg')
    }
]

const NestedDropdown = () => {

    const lang = useLang()
    const currentLanguage = languages.find((x) => x.lang === lang)

    return (
        <Dropdown id="language-dropdown" className="">
            <Dropdown.Toggle id="dropdown-basic" className={" bg-transparent fw-bold fs-6 px-2"}>
                {currentLanguage?.name}{' '}
                <img
                    className='w-15px h-15px rounded-1'
                    src={currentLanguage?.flag}
                    alt='metronic'
                />
            </Dropdown.Toggle>

            <Dropdown.Menu className={"w-175px py-4"}>
                {languages.map((l) => (
                    <div
                        className='menu-item px-3'
                        key={l.lang}
                        onClick={() => {
                            setLanguage(l.lang)
                        }}
                    >
                        <Link
                            to='#'
                            className={clsx('menu-link d-flex px-5', {active: l.lang === currentLanguage?.lang})}
                        >
              <span className='symbol symbol-20px me-4'>
                <img className='rounded-1' src={l.flag} alt='metronic'/>
              </span>
                            {l.name}
                        </Link>
                    </div>
                ))}

            </Dropdown.Menu>
        </Dropdown>
    );
};

export default NestedDropdown;
